import { render, staticRenderFns } from "./pdf-task.vue?vue&type=template&id=29c2db9d"
import script from "./pdf-task.vue?vue&type=script&lang=js"
export * from "./pdf-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c2db9d')) {
      api.createRecord('29c2db9d', component.options)
    } else {
      api.reload('29c2db9d', component.options)
    }
    module.hot.accept("./pdf-task.vue?vue&type=template&id=29c2db9d", function () {
      api.rerender('29c2db9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/pdf-task.vue"
export default component.exports